export default __webpack_public_path__ + "img/7241324d3ddf26edcc7d5edf0c28641d.png";